import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900">专题合集</h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 hover:border-accent-200 hover:shadow-sm transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-2xl bg-accent-100/80 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-200">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-foreground-900 whitespace-nowrap">
                {item.name}
              </h3>
              <span className="text-xs text-foreground-400 bg-background-100 px-2.5 py-0.5 rounded-full">
                {item.count}部
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}